<template>
  <vx-card>
    <place-edit
      @done="$router.push({ name: 'system-business-edit', params: { id: $route.params.businessId } })"
    />
  </vx-card>
</template>

<script>
import PlaceEdit from '@/views/components/forms/PlaceEdit'

export default {
  name: 'BusinessPlaceEdit',
  components: { PlaceEdit }
}
</script>

<style scoped></style>
